import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import Endpoints from "../../../domain/endpoints";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import { FetchState } from "../../../domain/models/fetch-state";
import { RemoteFetchTarget } from "../../../data/usecases/target/remote-fetch-target";
import {
  PaginatedType,
  TargetFilterType,
  TargetType,
} from "../../../domain/models/target/target-type";
import { FetchTarget } from "../../../domain/useages/target/fetch-target";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchTargetInterface {
  TargetData: TargetType[];
  pageData: PaginatedType;
  TargetState: FetchState;
  fetchTarget: Function;
  TargetFilter: TargetFilterType;
  currentPageNumber: number;
  handlePageNumber: Function;
}

const currentDate = new Date();
const year = currentDate.getFullYear();
const month = String(currentDate.getMonth() + 1).padStart(2, "0");
const monthYear = `${year}${month}`;

const initialStates = {
  TargetData: [],
  TargetState: FetchState.DEFAULT,
  TargetFilter: { month_year: monthYear, page: 1 } as TargetFilterType,
  currentPageNumber: 1,
  pageData: {} as PaginatedType,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchTargetSlice: StateCreator<FetchTargetInterface> = (
  set
) => ({
  ...initialStates,
  handlePageNumber: (pageNo: number) => {
    set(() => ({ currentPageNumber: pageNo }));
  },
  fetchTarget: async (payload: FetchTarget.Params) => {
  const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
  const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteTarget = new RemoteFetchTarget(
      `${BASE_URL}${Endpoints.FETCH_TARGET}`,
      axiosHttpClient
    );

    set(() => ({ TargetState: FetchState.LOADING }));
    let result = await remoteTarget.fetch(payload);
    if (result.success && result.targets.length !== 0) {
      set(() => ({
        TargetData: result.targets,
        TargetState: FetchState.SUCCESS,
        pageData: result.paginated,
      }));
    } else {
      set(() => ({ TargetState: FetchState.ERROR }));
    }
  },
});
